<div *ngIf="rulesAccepted" @fade>
  <nav class="roadmap-nav" mat-tab-nav-bar mat-stretch-tabs [tabPanel]="tabPanel" color="primary">
    <a *ngFor="let link of navLinks" mat-tab-link #rla="routerLinkActive"
      [active]="isViewInitialized && isLinkActive(rla)" [routerLink]="link.path"
      routerLinkActive="cri-admin-tabs-active">
      <mat-icon *ngIf="link.icon">{{ link.icon }}</mat-icon>
      <strong *ngIf="link.label"><em>{{ link.label }}</em></strong>
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
<div *ngIf="!rulesAccepted" class="container my-3 norms-container" @fade>
  <div class="row">
    <div class="col">
      <h1>Norme di utilizzo</h1>
      <hr />
    </div>
  </div>
  <div class="row my-2 px-2 norms-text-row">
    <div class="col">
      <p><strong>Uso del veicolo:</strong></p>
      <ul>
        <li>Il veicolo CRI potrà essere condotto dal facente richiesta purché sia in possesso di regolare patente di
          guida
          CRI in corso di validità che lo abiliti alla guida.</li>
        <li>Il veicolo non potrà essere condotto da altre persone.</li>
        <li>Il facente richiesta dichiara di essere a conoscenza delle norme del Codice della Strada e del Testo Unico
          CRI
          per la circolazione dei veicoli. Qualsiasi infrazione alle suddette norme saranno a lui contestate ed
          eventuali
          sanzioni saranno a suo carico.</li>
        <li>Il facente richiesta dichiara di essere consapevole della responsabilità penale in cui incorre nelle ipotesi
          di sottoscrizione di dichiarazioni mendaci e delle relative sanzioni penali di cui all’art. 76 del D.P.R.
          445/2000.</li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col btn-col">
      <button type="button" (click)="onRulesAccept()" class="btn btn-primary">Accetta</button>
    </div>
  </div>
</div>